import { EnvironmentProviders, InjectionToken, makeEnvironmentProviders, Provider } from '@angular/core';
import { ValidationErrorMessages } from '../../types/controls-error';
import ERROR_MESSAGES_VALUE from '../../constants/control-error-messages';

export const ERROR_MESSAGES = new InjectionToken<ValidationErrorMessages>('Error Messages');

export function provideValidationErrorMessages(): EnvironmentProviders {
  const providers: Provider[] = [
    {
      provide: ERROR_MESSAGES,
      useValue: ERROR_MESSAGES_VALUE
    }
  ];

  return makeEnvironmentProviders(providers);
}
